import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/styles';
import GenericButton from './genericButton';
import GenericButtonGroup from './genericButtonGroup';
import Groups from './groups/index';
import { goOutGroup } from './groups/goOutGroup';

const useStyles = makeStyles(() => ({
  divider: {
    height: 10,
    backgroundColor: '#f1f1f1',
  },
}));

const Menu = ({ ...props }) => {
  const { mobile } = props;
  const classes = useStyles();
  return (
    <div>
      {Groups.map(
        (group, index) =>
          group.length > 0 && (
            <React.Fragment key={index}>
              <Divider className={classes.divider} />
              <GenericButtonGroup group={group} mobile={mobile} />
            </React.Fragment>
          ),
      )}
      <Divider className={classes.divider} />
      <GenericButton group={goOutGroup} />
    </div>
  );
};

Menu.propTypes = {
  mobile: PropTypes.bool,
};

export default Menu;
